import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ number, label }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="font-mono text-xs font-medium text-[#2563EB]">{number}</span>
    <span className="h-px w-8 bg-[#2563EB]" aria-hidden="true" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#52525B]">{label}</span>
  </div>
);
